import { Observable, Subject, timer, fromEvent } from 'rxjs';
import { first, throttleTime } from 'rxjs/operators';
export var MapsAPIKey = 'AIzaSyAWGm7lJKidOYOZwusjGXLXgJApnXf5XQ8';
// import { pageList } from 'site/pages/pages'
var pageChangeSubject = new Subject();
// // Make pageChangeObservable an observable
// let pageChangeObservable = pageChangeSubject.asObservable()
//     .pipe(
//         // tap(p => console.log(`Before filter: ${p}`)),
//         // tap(p => console.log(`>${window.location.pathname}< >${p}<`)),
//         // tap(page => {
//         //     console.log(`PCOb1 ${window.location.pathname} ${page}`);
//         //     }),
//         // filter(page => (window.location.pathname !== page)),
//         // tap(page => {
//         //     console.log(`PCOb ${window.location.pathname} ${page}`);
//         //     }),
//         map(page => page===null?window.location.pathname:page), // Passing null as the page forces a rendering of the currect path (initial view)
//         // tap(page => {
//         //     console.log('pushing history')
//         //     history.pushState({}, '', page.toString())
//         // }),
//         // tap(p => {
//         //     console.log(`After filter: ${p}`);
//         //     // debugger;
//         // }),
//         map(page => {
//             // let urlPath = page.location.split('/').filter(p => p.length > 0);
//             return pageList.find(p => (!p.hide && ('/'+p.pageLocation === page))) || pageList.find(p => p.pageLocation === 'notfound');
//         }),
//         // tap(p => console.log(`Before share: ${p}`)),
//         share() // Only run the piped operators once for all subscribers
//     );
var triggerPageChange = function (page) {
    // console.log(`TPC: ${window.location.pathname} ${page}`)
    if (page) {
        pageChangeSubject.next({ page: page, previousLocation: window.location });
    }
    else {
        pageChangeSubject.next(null);
    }
};
var linkClick = function (event, location, title, state) {
    if (title === void 0) { title = ''; }
    if (state === void 0) { state = {}; }
    event.preventDefault();
    var previousLocation = Object.assign({}, window.location);
    if (location.valueOf() != (window.location.pathname + window.location.hash).valueOf()) {
        history.pushState({}, '', location.toString());
    }
    pageChangeSubject.next({ page: location, previousLocation: previousLocation });
};
window.onpopstate = function (event) {
    // console.log(`Popstate: `)
    // console.log(location)
    triggerPageChange(location.pathname);
};
// Script loaded on first subscribe
var mapsLoaded = false;
var mapQueue = [];
window.initMap = function () {
    mapsLoaded = true;
    mapQueue.map(function (m) { return m(); });
};
var mapLoadedObservable = Observable.create(function (sub) {
    if (mapsLoaded) {
        sub.next(true);
    }
    else {
        mapQueue.push(function () { return sub.next(true); });
        if (mapQueue.length === 1) { // This was the first item
            var newScript = document.createElement("script");
            newScript.setAttribute("type", "text/javascript");
            // Dec 23 - now using initMap
            // newScript.onload = () => {
            //     mapsLoaded = true;
            //     mapQueue.map(m => m());
            // };
            newScript.src = 'https://maps.googleapis.com/maps/api/js?key=' + MapsAPIKey + '&callback=initMap';
            document.getElementsByTagName("body")[0].appendChild(newScript);
            //     <script async
            //     src="https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY&callback=initMap">
            // </script>
        }
    }
});
var preloadMaps = function (loadDelay) {
    if (loadDelay === void 0) { loadDelay = 5000; }
    timer(loadDelay)
        .pipe(first())
        .subscribe(function () {
        mapLoadedObservable.subscribe();
    });
};
// pixLoadedObservable.subscribe({
//     next: (s) => {
//         console.log(`PixLoaded: ${s}`);
//     }
// });
var scrollObservable = fromEvent(window, 'scroll')
    .pipe(throttleTime(200, undefined, { trailing: true }));
// scrollObservable.subscribe({
//     next: (event) => {
//         console.log('pushing history without hash')
//         history.pushState({}, '', window.location.pathname.toString());
//     }
// });
export { pageChangeSubject, 
// pageChangeObservable,
triggerPageChange, scrollObservable, mapLoadedObservable, linkClick, preloadMaps };
//# sourceMappingURL=rxjs.js.map